import {
  // REFRESH_TABLE_MESSAGE,
  // REFRESH_TABLE_LOADING,
  REFRESH_TABLE,
} from "../constants/TableComponentConstants";

const initState = {
  loading: false,
  message: "",
  showMessage: false,
  error: false,
  refresh: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case REFRESH_TABLE: {
      return {
        ...state,
        refresh: action.refresh,
        // loading: true,
      };
    }
    // case REFRESH_TABLE_MESSAGE: {
    //   return {
    //     ...state,
    //     error: action.error,
    //     message: action.message,
    //     showMessage: action.showMessage,
    //   };
    // }
    // case REFRESH_TABLE_LOADING: {
    //   return {
    //     ...state,
    //     loading: action.loading,
    //   };
    // }
    default:
      return state;
  }
};
